import CountryTypes from 'store/actionTypes/country'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {}
}

const country = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case CountryTypes.GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case CountryTypes.GET_COUNTRY_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case CountryTypes.GET_SYSTEM_COUNTRIES_SUCCESS:
      return { ...state, systems: payload?.countries?.items }
    case CountryTypes.UPDATE_FILTER_COUNTRY_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default country
